import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { validateIframeRegex } from 'helper/validators';
import { IconMaximizeNew, IconMinimizeNew, DarkButton } from '@lyearn-team/frontend-components';
import c from 'classnames';
import s from './styles';

export default class EmbedDark extends Component {
  static propTypes = {
    card: PropTypes.object.isRequired
  };

  state = {
    zoom: false
  };

  renderContent = (src, type) => {
    if (type === 'url') {
      return (
        <div className="embed--url_block" style={{ width: '100%' }}>
          <div className="embed--url_iFrame">
            <iframe title="URL" src={src} width="100%" height="900" />
          </div>
        </div>
      );
    }
    if (type === 'embedly') {
      const data = JSON.parse(src);
      if (data.type === 'video') {
        return (
          <div
            className="embedBlockIframeContainer"
            dangerouslySetInnerHTML={{ __html: data.html }}
          />
        );
      }
      if (data.type === 'link') {
        let renderImageLink = '';
        const headerStyle = {
          fontSize: '25px',
          lineHeight: '54px',
          margin: '16px 0',
          color: '#e3e3e3',
          fontFamily: 'NotoSerif'
        };
        const descriptionStyle = {
          fontSize: '13px',
          color: '#e3e3e3',
          fontFamily: 'NotoSerif',
          lineHeight: '25px',
          fontWeight: '300'
        };
        const readMoreStyle = {
          fontSize: '13px',
          color: '#e3e3e3',
          fontFamily: 'NotoSerif',
          lineHeight: '54px',
          fontWeight: '800',
          letterSpacing: '0.06rem',
          textTransform: 'uppercase'
        };
        if (data.url) {
          renderImageLink = (
            <a href={data.url} target="_blank">
              <img
                src="https://dndw32r4edmw5.cloudfront.net/lyearn/assets/embed_thumb_image.png"
                alt=""
              />
            </a>
          );
        } else {
          renderImageLink = (
            <img
              src="https://dndw32r4edmw5.cloudfront.net/lyearn/assets/embed_thumb_image.png"
              alt=""
            />
          );
        }
        return (
          <div className="embed embed--link embed--rich">
            {!!data.url && !!data.thumbnail_url && (
              <a href={data.url} rel="noopener noreferrer" target="_blank">
                <img alt="" className="embed__img" src={data.thumbnail_url} />
              </a>
            )}
            {!data.hideMetadata && (
              <div className="embed__meta__content">
                {!!data.url && (
                  <h2 style={headerStyle}>
                    <a
                      href={data.provider_url}
                      rel="noopener noreferrer"
                      target="_blank"
                      className=""
                      style={{ color: '#e3e3e3' }}
                    >
                      {data.title}
                    </a>
                  </h2>
                )}
                {!!data.description && <p style={descriptionStyle}>{data.description}</p>}
                {!data.description && (
                  <p className="embed__empty_description_image brand--body">{renderImageLink}</p>
                )}
                {data.provider_name && (
                  <a
                    // className="embed__readMore"
                    href={data.provider_url}
                    rel="noopener noreferrer"
                    target="_blank"
                    style={readMoreStyle}
                  >
                    Read more {data.provider_name}
                  </a>
                )}
              </div>
            )}
          </div>
        );
      }
    } else if (type === 'iframe') {
      return (
        <div className="embedBlockIframeContainer" dangerouslySetInnerHTML={{ __html: src }} />
      );
    } else if (type === 'richContent') {
      const data1 = JSON.parse(src);
      const isIframe = validateIframeRegex.test(data1.embedlyData.html);
      if (isIframe) {
        return (
          <div
            className="embedBlockIframeContainer"
            dangerouslySetInnerHTML={{ __html: data1.embedlyData.html }}
          />
        );
      }
      return <iframe title="Rich Content" src={data1.userInput} width="706" height="900" />;
    }
    return null;
  };

  renderZoomBtn = () => {
    return (
      <DarkButton.IconButton
        className={c(s.zoomBtn, this.state.zoom ? 'zoom' : '')}
        onClick={() => this.setState({ zoom: !this.state.zoom })}
      >
        {this.state.zoom ? <IconMinimizeNew /> : <IconMaximizeNew />}
      </DarkButton.IconButton>
    );
  };

  render() {
    const cardMeta = JSON.parse(this.props.card.cardMeta);
    const embedType = cardMeta.embedType;
    const isMobile = window.innerWidth < 768;
    const url = cardMeta.url;

    let wrapperStyle = {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      backgroundColor: embedType === 'embedly' ? '#14181e' : '#fff',
      padding: embedType === 'embedly' ? '0px' : '40px'
    };
    if (isMobile) {
      wrapperStyle.padding = 15;
    }
    if (this.state.zoom) {
      wrapperStyle = {
        ...wrapperStyle,
        position: 'fixed',
        top: 0,
        left: 0,
        padding: isMobile ? '16px' : '3rem 10vw',
        width: '100vw',
        height: '100vh',
        overflow: 'auto'
      };
    }

    return (
      <div className="block-embed" style={{ position: 'relative' }}>
        <div className="">
          <div style={wrapperStyle}>
            {embedType === 'url' ? this.renderZoomBtn() : null}
            {this.renderContent(url, embedType)}
          </div>
        </div>
      </div>
    );
  }
}
